import {getParameterByName} from '../utils/tools';

const SET_TITLE = 'scratch-gui/Homework/SET_TITLE';
const SET_URL = 'scratch-gui/Homework/SET_URL';
const SET_CLASS_ID = 'scratch-gui/Homework/SET_CLASS_ID';
const SET_CLASS_NAME = 'scratch-gui/Homework/SET_CLASS_NAME';
const SET_COURSE_ID = 'scratch-gui/Homework/SET_COURSE_ID';
const SET_LESSON_ID = 'scratch-gui/Homework/SET_LESSON_ID';
const SET_UNIT_ID = 'scratch-gui/Homework/SET_UNIT_ID';

const classId = getParameterByName('classId');
const className = getParameterByName('className');
const courseId = getParameterByName('courseId');
const lessonId = getParameterByName('lessonId');
const title = getParameterByName('title');
const unitId = getParameterByName('unitId');
const url = getParameterByName('url');

const initialState = {
    classId: classId ? classId : 0,
    className: className ? className : '',
    courseId: courseId ? courseId : 0,
    lessonId: lessonId ? lessonId : 0,
    title: title ? title : 'New Project',
    unitId: unitId ? unitId : 0,
    url: url ? url : ''
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_TITLE:
        return Object.assign({}, state, {
            title: action.title
        });
    case SET_URL:
        return Object.assign({}, state, {
            url: action.url
        });
    case SET_CLASS_ID:
        return Object.assign({}, state, {
            classId: action.classId
        });
    case SET_CLASS_NAME:
        return Object.assign({}, state, {
            className: action.className
        });
    case SET_COURSE_ID:
        return Object.assign({}, state, {
            courseId: action.courseId
        });
    case SET_UNIT_ID:
        return Object.assign({}, state, {
            unitId: action.unitId
        });
    case SET_LESSON_ID:
        return Object.assign({}, state, {
            lessonId: action.lessonId
        });
    default:
        return state;
    }
};

const setTitle = function (t){
    return {
        type: SET_TITLE,
        title: t
    };
};

const setUrl = function (u) {
    return {
        type: SET_URL,
        url: u
    };
};

const setClassId = function (clId) {
    return {
        type: SET_CLASS_ID,
        classId: clId
    };
};

const setClassName = function (cName) {
    return {
        type: SET_CLASS_NAME,
        className: cName
    };
};


const setCourseId = function (cId) {
    return {
        type: SET_COURSE_ID,
        courseId: cId
    };
};

const setLessonId = function (lId) {
    return {
        type: SET_LESSON_ID,
        lessonId: lId
    };
};

const setUnitId = function (uId) {
    return {
        type: SET_UNIT_ID,
        unitId: uId
    };
};

export {
    reducer as default,
    initialState as homeworkInitialState,
    setTitle,
    setUrl,
    setClassId,
    setClassName,
    setCourseId,
    setLessonId,
    setUnitId
};
